export default __webpack_public_path__ + "static/media/16.9d7846fd.jpg";